import { Modal } from '@app/components/various/Modal';
import { getIsSelectionImportLoading, resetSelectionImport } from '@app/ducks';
import { useModalVisibility } from '@app/utils/hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { SelectionImportContent } from './SelectionImportContent';

export const SelectionImportModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['common', 'selections', 'validation']);
  const { isModalVisible, hideModal } = useModalVisibility('SelectionImportModal');
  const isImportLoading = useSelector(getIsSelectionImportLoading);

  React.useEffect(() => {
    return () => {
      dispatch(resetSelectionImport());
    };
  }, [dispatch]);

  const handleModalClosed = () => {
    dispatch(resetSelectionImport());
  };

  return (
    <Modal
      title={t('selections:import_selection_csv')}
      isOpen={isModalVisible}
      size="medium"
      shouldCloseOnEsc={!isImportLoading}
      shouldCloseOnOverlayClick={!isImportLoading}
      hasCloseButton={!isImportLoading}
      onClose={hideModal}
      modalClosedCallback={handleModalClosed}
    >
      <div className="flex min-h-36 flex-col items-center justify-center">
        <SelectionImportContent />
      </div>
    </Modal>
  );
};
